export function mobileDeviceIsSmall() {
  return window.innerHeight < 500;
}